import React from 'react';
import { formatPrice } from '../../../../utils/formatPrice';
import { SiteLocale, TooltipRecord } from '../../../../../types/dato';
import { classNames } from '@payfit/growth-platform-brand-system-v2';
import { Popover } from 'libs/growth-platform-brand-system-v2/src/components/Popover';
import { decorationUnderlineDotted } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { PricingPopoverContent } from '../PricingPopoverContent';
type BaseProps = {
  price?: number;
  discount?: number;
  locale: SiteLocale;
  label?: string;
  tooltip?: TooltipRecord | null;
};

const BaseDiscount = ({ price, locale, label, tooltip }: BaseProps) => {
  return (
    <>
      +{' '}
      <span className={classNames('line-through')}>
        {!!price && formatPrice(price, locale)}
      </span>{' '}
      <span>{!!price && formatPrice(price, locale)}</span>
      {tooltip && (
        <Popover
          position={'bottom'}
          label={
            <span className={classNames(decorationUnderlineDotted)}>
              {label}
            </span>
          }
        >
          <PricingPopoverContent {...tooltip} className="md:w-[280px]" />
        </Popover>
      )}
      {!tooltip && label}
    </>
  );
};

export default BaseDiscount;
